import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg material-icons-outlined" }, "language", -1)
const _hoisted_2 = { class: "-mx-5 -my-3" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DropdownMenu, {
      expanded: _ctx.expanded,
      onToggleExpanded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
    }, {
      icon: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
              return _withDirectives((_openBlock(), _createElementBlock("li", {
                tabindex: "0",
                class: _normalizeClass([[
							locale === _ctx.$i18n.locale
								? 'bg-primary bg-opacity-20 text-primary font-semibold'
								: 'hover:bg-light',
						], "flex px-8 py-2 transition-colors cursor-pointer items-top duration75"]),
                key: 'locale-' + locale,
                onClick: ($event: any) => (_ctx.onLocaleChange(locale))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t("locales." + locale)), 1)
              ], 10, _hoisted_4)), [
                [_directive_wave]
              ])
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["expanded"])
  ]))
}